import axios from "axios";
import config from "../config";
import { getAccessToken } from "../helpers/api";
import { refreshAccessToken } from "./utils";

axios.interceptors.response.use(
    function (response) {
        return response.data ? response.data : response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        let message;
        switch (error.status) {
            case 500:
                message = "Internal Server Error";
                break;
            case 401:
                message = "Invalid credentials";
                break;
            case 404:
                message = "Sorry! the data you are looking for could not be found";
                break;
            default:
                message = error.message || error;
        }
        return Promise.reject(message);
    }
);
export const apiInstance = axios.create({
    baseURL: config.get("API_URL"),
    timeout: 10000, // Set a reasonable timeout
    headers: {
        "Content-Type": "application/json",
    },
});

export const postApi = async (path, data, isFormData = false) => {
    const accessToken = localStorage.getItem("authUser");
    let refreshToken = localStorage.getItem("refreshToken")?.replace(/^"|"$/g, "");
    const token = accessToken?.replace(/^"|"$/g, "");
    if (!refreshToken || !accessToken)
        ({
            error: "Session Expired",
        });
    try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 seconds
        const response = await apiInstance.post(path, data, {
            headers: {
                "Content-Type": isFormData ? "multipart/form-data" : "application/json",
                Authorization: `Bearer ${token}`,
            },
            signal: controller.signal,
            timeout: 30000,
        });

        clearTimeout(timeoutId);
        if (response.status === 401) {
            const newToken = await refreshAccessToken(); // Refresh token
            if (newToken) {
                return postApi(path, data, isFormData); // Retry the request with new token
            }
        }
        return { response: response.data || null };
    } catch (error) {
        if (error?.response?.status === 401 || error.status === 401) {
            refreshToken = await refreshAccessToken(); // Refresh token
            if (token) {
                return postApi(path, data, isFormData); // Retry the request with new token
            } else {
                return { error: 401 };
            }
        }
        console.log("err.....", error);
        return { error: error?.response?.data || error };
    }
};
export const putApi = async (path, data, isFormData = false) => {
    const accessToken = localStorage.getItem("authUser");
    let refreshToken = localStorage.getItem("refreshToken")?.replace(/^"|"$/g, "");
    const token = accessToken?.replace(/^"|"$/g, "");
    if (!refreshToken || !accessToken)
        ({
            error: "Session Expired",
        });
    try {
        const response = await apiInstance.put(path, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": isFormData ? "multipart/form-data" : "application/json",
            },
        });
        if (response.status === 401) {
            const newToken = await refreshAccessToken(); // Refresh token
            if (newToken) {
                return putApi(path, data, isFormData); // Retry the request with new token
            }
        }
        return { response: response };
    } catch (error) {
        if (error.response.data.error === "Incorrect password!") {
            return { error: "Incorrect password!" };
        }
        if (error?.response?.status === 401 || error === "Request failed with status code 401") {
            refreshToken = await refreshAccessToken(); // Refresh token
            if (token) {
                return putApi(path, data, isFormData); // Retry the request with new token
            } else {
                return { error: 401 };
            }
        } else {
            console.log("err.....", error);
            return { error: error?.response?.data || error };
        }
    }
};

// Main GET API function
export const getApi = async (path) => {
    let refreshToken = localStorage.getItem("refreshToken")?.replace(/^"|"$/g, "");
    let token = localStorage.getItem("authUser")?.replace(/^"|"$/g, "");
    if (!refreshToken && !token) {
        return {
            error: 401,
        };
    }
    try {
        const response = await apiInstance.get(path, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 401) {
            const newToken = await refreshAccessToken(); // Refresh token
            if (newToken) {
                return getApi(path); // Retry the request with new token
            }
        }
        return { response };
    } catch (error) {
        console.log("error>>>>>>>>>>>>", error);
        if (
            error === "Request failed with status code 401" ||
            error.status === 401 ||
            error.response.status === 401 ||
            error === "Invalid credentials" ||
            error === 401
        ) {
            token = await refreshAccessToken(); // Refresh token
            if (token) {
                return getApi(path); // Retry the request with new token
            } else {
                // window.location.href = `${config.get("FRONT_END_URL")}/login`;
                return { error: 401 };
            }
        }
        // console.error("API Error:", error);
        return { error: error.response?.data || "Something went wrong" };
    }
};

export const deleteApi = async (path, data) => {
    const accessToken = localStorage.getItem("authUser");
    let refreshToken = localStorage.getItem("authUser")?.replace(/^"|"$/g, "");
    const token = accessToken.replace(/^"|"$/g, "");
    try {
        const response = await apiInstance.delete(path, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            data: data,
        });
        if (response.status === 401) {
            const newToken = await refreshAccessToken(); // Refresh token
            if (newToken) {
                return deleteApi(path, data); // Retry the request with new token
            }
        }
        return { response: response };
    } catch (error) {
        if (
            error?.response?.status === 401 ||
            error?.status === 401 ||
            error === "Request failed with status code 401" ||
            error === "Invalid credentials" ||
            error === 401
        ) {
            refreshToken = await refreshAccessToken(); // Refresh token
            if (refreshToken) {
                return getApi(path); // Retry the request with new token
            } else {
                return { error: 401 };
            }
        }
        // console.error("API Error:", error);
        return { error: error.response?.data || "Something went wrong" };
        // return error;
    }
};
